import React from 'react';
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faMapMarkerAlt, faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import Footer from "../components/common/footer";
import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
    const currentSEO = SEO.find(item => item.page === "contact");

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Contact | ${INFO.main.title}`}</title>
                <meta name="description" content={currentSEO?.description} />
                <meta name="keywords" content={currentSEO?.keywords.join(", ")} />
            </Helmet>

            <div className="page-content">
                <div className="content-wrapper">
                    <div className="contact-container">
                        <div className="title contact-title">
                            Get in Touch
                        </div>
                        <div className="subtitle contact-subtitle">
                            Book your appointment or connect with me on social media
                        </div>

                        <div className="contact-cards">
                            <div className="contact-card social-card">
                                <div className="contact-card-icon">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </div>
                                <div className="contact-card-title">
                                    Follow Me
                                </div>
                                <div className="contact-card-body">
                                    Stay updated with my latest work and hair inspiration
                                </div>
                                <a 
                                    href={INFO.socials.instagram}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-card-link"
                                >
                                    @annaveret_hair
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="page-footer">
                        <Footer />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Contact; 